import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { company } from '~/company/Company';

import { userStore } from '~/stores';

export const usePickupAddress = (searchParams: URLSearchParams) => {
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    const pickup = company.pickupAddress;

    if (searchParams.get('pickup') !== 'true' || !pickup) {
      return;
    }

    const { coordinates, address, city, country, zip } = pickup;

    userStore.setDeliveryAddress({
      address1: address,
      addressId: null,
      comment: '',
      address2: '',
      addressFloor: '',
      addressBld: '',
      addressApt: '',
      coordinates,
      shortAddress: address,
      instructions: [],
      city,
      country,
      placeId: '',
      region: '',
      zip,
      type: 'home',
    });

    searchParams.delete('pickup');
    searchParams.delete('modal');
    setSearchParams(searchParams, { replace: true });
  }, []);
};
